module.exports = __webpack_public_path__ + "img/Compact-SR-Overview.2a201859.jpg";